module.exports = __webpack_public_path__ + "static/media/AdminNómina_Permisos.0f205488.svg";